export default {
  inject: ['load'],
  data() {
    return {
      isDrugVehicleTypeModalOpen: false,
      confimType: '',
      drugId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      searchModal: false,
      isSearch: false,
      modalIcon: '',
      drugManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'عنوان', value: 'title', align: 'center' },
        { text: 'کد', value: 'code', align: 'center' },
        { text: 'گروه دارو', value: 'group', align: 'center' },
        { text: 'واحد دارو', value: 'unit', align: 'center' },
        { text: 'نحوه تجویز', value: 'orderType', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      searchDrugGroupId: null,
      searchUnitId: null,
      searchText: '',
      searchCode: '',
      selectedDrugId: null,
    };
  },
  methods: {
    // drugVehicleType
    setOpeningDrugVehicleTypeModal: function (value) {
      this.isDrugVehicleTypeModalOpen = value;
    },
    openDrugVehicleTypeModal: function (id) {
      this.getAllVehicleTypes();
      this.getAllDrugVehicleType(id);
      this.selectedDrugId = id;
      this.setOpeningDrugVehicleTypeModal(true);
      this.allSelectedVehicleTypes = [];
    },
    closeDrugVehicleTypeModal: function () {
      this.selectDrugId(null);
      this.setOpeningDrugVehicleTypeModal(false);
    },
    selectDrugId: function (id) {
      this.selectedDrugId = id;
    },

    haveDublicated: function (id) {
      return [...this.allSelectedVehicleTypes].some(
        (selectedVehicleType) => selectedVehicleType?.id === id,
      );
    },
    addNewVehicleType: function (vehicle) {
      if (!this.haveDublicated(vehicle?.id))
        this.allSelectedVehicleTypes = [...this.allSelectedVehicleTypes, vehicle];
      else return;
    },
    addAllVehicleTypes: function () {
      this.allSelectedVehicleTypes = [...this.allVehicleTypes];
    },
    deleteVehicleType: function (id) {
      this.allSelectedVehicleTypes = [...this.allSelectedVehicleTypes].filter(
        (selectedVehicleType) => selectedVehicleType?.id !== id,
      );
    },
    deleteAllVehicleTypes: function () {
      this.allSelectedVehicleTypes = [];
    },
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.$router.push({ name: 'addDrug' });
      } else if (type == 2) {
        this.$router.push({ name: 'addDrug', params: { id: id } });
      }
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف دارو';
        this.$refs.confirm.text = 'از حذف دارو اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteDrugFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.drugId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    //search
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getListOfDrugsWithPagination();
    },
    removeFilters: function () {
      this.searchDrugGroupId = null;
      this.searchUnitId = null;
      this.searchText = '';
      this.searchCode = '';
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getListOfDrugsWithPagination();
    },
    cancelSearch: function () {
      this.searchDrugGroupId = null;
      this.searchUnitId = null;
      this.searchText = '';
      this.searchCode = '';
      this.searchModal = false;
    },
    goToMoreInformation: function (id) {
      this.$router.push({ name: 'drugMoreInformation', params: { id: id } });
    },
  },
};
